import "./view.scss";
import marquee from "vanilla-marquee";

document.addEventListener("DOMContentLoaded", function () {
  const initMarqueeGroup = (selector, options = {}) => {
    const logoMarqueeBlocks = document.querySelectorAll(selector);

    if (!logoMarqueeBlocks?.length) return;

    logoMarqueeBlocks.forEach((logoMarqueeBlock) => {
      const logoMarqueeTrack = logoMarqueeBlock.querySelector(".marquee-items");

      if (!logoMarqueeTrack) return;

      logoMarqueeTrack.classList.add("logo-marquee-track--initializing");

      new marquee(logoMarqueeTrack, {
        speed: 50,
        duplicated: true,
        startVisible: true,
        recalcResize: true,
        gap: 0,
        ...options,
      });

      requestAnimationFrame(() => {
        logoMarqueeTrack.classList.add("logo-marquee-track--ready");
        logoMarqueeTrack.classList.remove("logo-marquee-track--initializing");
      });
    });
  };

  initMarqueeGroup(
    ".wp-block-thirtysix-blocks-logo-marquee .container.marquee-left"
  );
  initMarqueeGroup(
    ".wp-block-thirtysix-blocks-logo-marquee .container.marquee-right",
    { direction: "right" }
  );
});
